import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { CustomerApi } from '_api';
import { handleError, handleResponse } from '_helpers/api';
import { createOrderOptions } from '_helpers/orders';
import { selectActiveOrderId } from '_store/order/selector';
import { refreshActiveOrderId } from '_store/order/slice';

export const getOrders = createAsyncThunk(
  'orders/getOrders',
  async function ({ customerId }, { dispatch, getState, rejectWithValue }) {
    try {
      // const response = await CustomerApi.getOrders({ customerId });
      // const einResponse = await CustomerApi.getOrders({ customerId, category: 'EIN' });
      // const incResponse = await CustomerApi.getOrders({ customerId, category: 'INC' });
      // const incStatesResponse = await CustomerApi.getOrders({ customerId, category: 'INC_States' });
      const response = await CustomerApi.getOrders({ customerId, category: 'ACCOUNTING' });
      const rawData = handleResponse(response);
      const parenOrdersIds = rawData?.map(({ parentOrderUid }) => parentOrderUid);
      const parentOrdersResponse = await Promise.all(
        parenOrdersIds
          ?.filter((parentOrderId) => !!parentOrderId)
          ?.map((orderId) => CustomerApi.getOrder({ customerId, orderId }))
      );
      const parentsOrdersData = handleResponse(parentOrdersResponse);
      const data = rawData?.map((order) => {
        const parent = parentsOrdersData?.find((parent) => parent.uid === order.parentOrderUid);

        if (parent) {
          return { ...order, parent };
        }

        return order;
      });

      const currentOrderId = selectActiveOrderId(getState());
      const filteredOrderOptions = createOrderOptions(data);
      const defaultOrderId = filteredOrderOptions[0]?.value;

      if (!currentOrderId && defaultOrderId) {
        dispatch(refreshActiveOrderId(defaultOrderId));
      }

      return data;
    } catch (error) {
      const processedError = handleError(error);
      return rejectWithValue(processedError);
    }
  }
);

const ordersSlice = createSlice({
  name: 'orders',
  initialState: {
    data: [],
    error: null,
    loading: false,
  },
  reducers: {
    resetError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrders.pending, (state) => {
        state.error = null;
        state.loading = true;
      })
      .addCase(getOrders.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(getOrders.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { resetError } = ordersSlice.actions;

export default ordersSlice.reducer;
